import { render } from "./LoginPage.vue?vue&type=template&id=482e027b"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"
script.render = render

export default script